import { useEffect, useState } from "react";
import { IDebentureSearch, useFindDebenture } from "../hooks/useFindDebenture";
import FormField from "./FormField";
import Text from "./Text";
import Container from "./Container";
import { InputText } from "primereact/inputtext";
import Icon from "./Icon";
import { ProgressSpinner } from "primereact/progressspinner";
import { formatDebentureYieldShort } from "../commons/debenture-yield";

export interface IDebentureSearchSelectorProps {
    selectedDebenture: IDebentureSearch|undefined;
    selectDebenture: (debenture: IDebentureSearch|undefined) => void;
    hasError?: boolean;
    error?: string;
}

const DebentureSearchSelector = (props: IDebentureSearchSelectorProps) => {
    const {
        findDebentureByCode,
        loadingDebenture,
        debentureSearch,
        setDebentureSearch
    } = useFindDebenture();

    const [searchQueryTimeouted, setSearchQueryTimeouted] = useState<string>("");

    useEffect(() => {
        const timeout = setTimeout(() => {
            findDebentureByCode(searchQueryTimeouted);
        }, 1500);

        return () => clearTimeout(timeout);
    }, [searchQueryTimeouted]);

    return (
        <FormField
            id="debentureSearchSelector"
            label="Debênture"
            hasError={props.hasError}
            error={props.error}
        >
            <Container relative>
                <InputText 
                    value={props.selectedDebenture?.code ?? searchQueryTimeouted}
                    className="w-full pr-5"
                    placeholder="Procure pelo código"
                    invalid={props.hasError}
                    onChange={(e) => {
                        setSearchQueryTimeouted(e.target.value);
                    }}
                />
                
                {
                    props.selectedDebenture && <Icon 
                        name="pi-times"
                        className="absolute right-0 mr-1 p-2 text-red-500 bg-white"
                        onClick={() => {
                            props.selectDebenture(undefined);
                            setSearchQueryTimeouted("");
                            setDebentureSearch([]);
                        }}
                        style={{ transform: "translateY(-50%)", top: "50%" }}
                    />
                }
            </Container>
            {
                loadingDebenture && (
                    <Container center flexColumn className="my-progress-spinner p-4" gap={2}>
                        <ProgressSpinner className="w-2rem h-auto" />
                        <Text>Carregando...</Text>
                    </Container>       
                )
            }

            {
                !!debentureSearch.length && !props.selectedDebenture && !loadingDebenture && searchQueryTimeouted && <div className="bg-white w-full">
                    <ul className="list-none p-0 flex gap-2 flex-column">
                        {
                            debentureSearch.map(debenture => {
                                return (
                                    <li key={debenture.id}>
                                        <a 
                                            className="cursor-pointer" 
                                            onClick={() => {
                                                props.selectDebenture(debenture);
                                                setDebentureSearch([]);
                                            }}
                                        >
                                            {debenture.code}{formatDebentureYieldShort(debenture.index, debenture.interestRate) ? ` · ${formatDebentureYieldShort(debenture.index, debenture.interestRate)}` : ""}
                                        </a>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
            }
        </FormField>
    );
}

export default DebentureSearchSelector;